﻿import * as React from "react";

export interface INavigationTowerProps {
    bindComponent?: React.ReactNode;
}

export const NavigationTower: React.FunctionComponent<INavigationTowerProps> = (
    props,
): React.ReactElement => {
    if (props.bindComponent === null) {
        return null;
    }

    return <div className={`sidemenu-navtower`}>{props.bindComponent}</div>;
};
